import React, { useEffect, useState } from "react";
import "../style/global.css";
import Button from "../common/Button/Button.js";
import Oops from "../assets/Images/loanreject.gif";
import mixpanel from "mixpanel-browser";
import { notifyVisitorEvent } from "../api/action.js";

const NoMutualFundsPopup = () => {
  const [isIncorrectDetails, setIsIncorrectDetails] = useState(false);
  const [isInsufficientFunds, setIsInsufficientFunds] = useState(false);


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const panMobileStatus = urlParams.get('pan-mobile-status');
    const keyfrom = urlParams.get('keyfrom'); 

    if (panMobileStatus === 'notMatch') {
      setIsIncorrectDetails(true); 
    }

    if (keyfrom === 'successpage') {
      setIsInsufficientFunds(true);
    }


    
if(keyfrom === 'successpage'){

  const UserID = localStorage.getItem("UserId")
   

  const payload = {
    event_name: "Viewed_Less_MF",
    event_body: {
          "platform" : "m-site",
      },
  };


  notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor event:", error);
    });


  mixpanel.track("Viewed_Less_MF", {
    "Platform":"m-site",
   })
}


else if(panMobileStatus === 'notMatch'){

  const UserID = localStorage.getItem("UserId")
  
  const payload = {
    event_name: "Viewed_invalid_details",
    event_body: {
          "platform" : "m-site",
      },
  };

  notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor event:", error);
    });


  mixpanel.track("Viewed_invalid_details", {
    "Platform":"m-site",
   })
}
else{
  
  const UserID = localStorage.getItem("UserId")
  
  const payload = {
    event_name: "Viewed_No_MF",
    event_body: {
          "platform" : "m-site",
      },
  };

  notifyVisitorEvent(payload)
    .then((response) => {
      console.log("NotifyVisitor Event Sent:", response);
    })
    .catch((error) => {
      console.error("Error sending NotifyVisitor event:", error);
    });


  mixpanel.track("Viewed_No_MF", {
    "Platform":"m-site",
   })
}
   
     
  
  }, []);



  const handleRedirection = () => {
    const UserID = localStorage.getItem("UserId");
  
    let payload = {};
  
    if (isInsufficientFunds) {
      payload = {
        event_name: "Interacted_Less_MF",
        event_body: {
          platform: "m-site",
          "Clicked on": "Try Again",
        },
      };
    } else if (isIncorrectDetails) {
      payload = {
        event_name: "Interacted_invalid_details",
        event_body: {
          platform: "m-site",
          "Clicked on": "Try Again",
        },
      };
    } else {
      payload = {
        event_name: "Interacted_No_MF",
        event_body: {
          platform: "m-site",
          "Clicked on": "Try Again",
        },
      };
    }
  
    notifyVisitorEvent(payload)
      .then((response) => {
        console.log("NotifyVisitor Button Click Event Sent:", response.status);
        mixpanel.track(payload.event_name, {
          Platform: "m-site",
          "Clicked on": "Try Again",
        });
        if (response.status === 200) {
          window.location.href = "/";
        }
      })
      
      .catch((error) => {
        console.error("Error sending NotifyVisitor event:", error);
        
      });
      
  };
  
  


  return (
    <div className="no-funds-container">
      <div className="no-funds-content">
        <img src={Oops} alt="loanrejectimg" width={180} />
        
        <h2 className="oops-title mb-30">Oops!</h2>
        
        <p className="oops-message">
          {isInsufficientFunds
            ? "It seems you have insufficient mutual fund holdings! We recommend exploring other loan options available for you."
            : isIncorrectDetails
            ? "The details you entered are incorrect. Please double-check and try again."
            : "It seems you don’t have mutual fund holdings! We recommend exploring other loan options available for you."
          }
        </p>

        <div className="sticky-button-container">
          <Button
            sslSecure="false"
            onClick={()=>{handleRedirection()}} 
            btnName="Try Again"
          />
        </div>
      </div>
    </div>
  );
};

export default NoMutualFundsPopup;
